import Sold from '../src/Sold';
export default Sold;
